export default "__VITE_ASSET__BBuN4IRw__"